export const PERIODONTAL = [
  "PD1 - Stage 1 periodontal disease",
  "PD2 - Stage 2 periodontal disease",
  "PD3 - Stage 3 periodontal disease",
  "PD4 - Stage 4 periodontal disease"
];

export const FURCATION = [
  "F1 - Mild furcation",
  "F2 - Moderate furcation",
  "F3 - Severe furcation"
];

export const MOBILITY = [
  "M1 - Mild mobility",
  "M2 - Moderate mobility",
  "M3 - Severe mobility"
];

export const GINGIVITIS = [
  "GI1 - Mild gingivitis",
  "GI2 - Moderate gingivitis",
  "GI3 - Severe gingivitis"
];

export const CALCULUS = [
  "C1 - Mild calculus",
  "C2 - Moderate calculus",
  "C3 - Severe calculus"
];

export const ENAMEL = [
  "AB - Abrasion",
  "AT - Attrition",
  "CA - Caries",
  "E/D - Enamel defect",
  "E/H - Enamel hypoplasia",
  "E/HM - Enamel hypomineralization"
];

export const FRACTURE = [
  "T/FX/EI - Enamel infraction",
  "T/FX/EF - Enamel fracture",
  "T/FX/UCF - Uncomplicated crown fracture",
  "T/FX/CCF - Complicated crown fracture",
  "T/FX/UCRF - Uncomplicated crown-root fracture",
  "T/FX/CCRF - Complicated crown-root fracture",
  "T/FX/RF - Root fracture"
];

export const RESORPTION = [
  "TR1 - Stage 1 resorption",
  "TR2 - Stage 2 resorption",
  "TR3 - Stage 3 resorption",
  "TR4 - Stage 4 resorption",
  "TR5 - Stage 5 resorption"
];
